import React, { Component } from "react";

const currency_symbols = {
  USD: "$", // US Dollar
  ILS: "₪", // Israeli New Sheqel
};

export const calculatePages = (range, totalPages) => {
  if (!range) return 0;

  // If the range is a string like `1-10`, split it and calculate the number of pages
  if (typeof range === 'string') {
    const [start, end] = range.split('-').map(Number);
    if (start && end) {
      return end - start + 1;
    }
  }

  // If range is not a valid string, use the default `1-totalPages`
  return totalPages;
};


class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      printer: props.printer,
      settings: {
        size: "A4",
        copies: 1,
        color: false,
      },
      validPageRange: true,
    };
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.handleCopiesChange = this.handleCopiesChange.bind(this);
    this.handlePagesChange = this.handlePagesChange.bind(this);
    this.resetSettings = this.resetSettings.bind(this); // Bind the resetSettings method
  }

  resetSettings() {
    let defaultPages = `1-${this.props.pages}`;

    this.setState(
      {
        settings: {
          size: "A4",
          copies: 1,
          pages: defaultPages,
          color: this.state.settings.color || false,
        },
      }
    );

    if (document.querySelector("#settings-color-switch") && !document.querySelector("#settings-color-switch").classList.contains("toggle-off")) {
      $("#settings-color-switch u").click();
    }

    if (document.querySelector("#settings-double-switch") && !document.querySelector("#settings-double-switch").classList.contains("toggle-off")) {
      $("#settings-double-switch u").click();
    }
  }

  componentDidMount() {
    $("#menu-settings-bottom").on("click", ".toggle-switch", (e) => {
      const name = e.currentTarget.dataset.name;
      const state = e.currentTarget.classList.contains("toggle-off");
      let settings = this.state.settings;
      settings[name] = state;
      this.setState({ settings });
    });
  }

  componentDidUpdate(previousProps) {
    const { pdf } = this.props;
    const { settings } = this.state;

    const rangeValue = $("#page-range").val();
    if (rangeValue) {
      const [, pages] = rangeValue.split("-");
      if (previousProps.pdf !== pdf) {
        settings.copies = 1;
        settings.pages = pages;
        this.setState({ settings });
      }
    }
  }

  handleSizeChange(event) {
    const target = event.target;
    const settings = this.state.settings;
    const { value } = target;
    settings.size = value;
    this.setState({ settings });
  }

  handleCopiesChange(event) {
    const target = event.target;
    const settings = this.state.settings;
    const { value } = target;
    if (value === "" || Number(value) > 0) {
      settings.copies = value;
      this.setState({ settings });
    }
  }

  validatePageRange(numbers) {
    return (
      Number(numbers[0]) > 0 &&
      Number(numbers[0]) <= Number(numbers[1]) &&
      Number(numbers[1]) <= this.props.pages
    );
  }

  handlePagesChange(event) {
    const target = event.target;
    let settings = this.state.settings;
    const { value } = target;
    const index = value.indexOf("-");
    const numbers = value.split("-");
    if (
      (/^(\d+|\d+-\d+)(,?=(\d+|\d+-\d+))*$/.test(value) ||
        index === 0 ||
        index === value.length - 1) &&
      value !== "-"
    ) {
      settings.pages = value;
      this.setState({
        settings,
        validPageRange: this.validatePageRange(numbers),
      });
    }
  }

  render() {
    let duplexSupported = false;
    let colorSupported = false;
    let print = { sizes: [] };
    let scan = {
      duplex: false,
    };
    const aSizeRegex = /^iso[\-|_](a\d)/;
    const extractSizes = (sizes) =>
      Array.from(
        new Set(
          sizes
            .filter((s) => s.match(aSizeRegex))
            .map((s) => s.match(aSizeRegex)[1].toUpperCase())
        )
      );
    if (this.props.services.ipp) {
      if (this.props.services.ipp["sides-supported"]) {
        try {
          print.duplex =
            this.props.services.ipp["sides-supported"].filter((s) =>
              s.includes("two")
            ).length > 0;
        } catch (e) {}
      }
      if (this.props.services.ipp["media-default"]) {
        try {
          const matchedDefaultSize =
            this.props.services.ipp["media-default"].match(aSizeRegex);
          if (matchedDefaultSize) {
            print.defaultSize = matchedDefaultSize[1].toUpperCase();
          }
        } catch (e) {}
      }
      if (this.props.services.ipp["media-supported"]) {
        try {
          print.sizes = extractSizes(
            this.props.services.ipp["media-supported"]
          );
        } catch (e) {}
      }
      colorSupported = this.props.services.ipp["color-supported"]
        ? true
        : false;
    }

    const wsd = this.props.services.wsd;
    const escl = this.props.services.escl;

    if (escl) {
      try {
        scan.duplex = Object.values(
          escl.capabilities.Adf.AdfOptions.AdfOption
        ).includes("Duplex");
      } catch (e) {}
    }

    if (wsd) {
      if (wsd.scanner) {
        if (wsd.scanner.ScannerConfiguration) {
          if (wsd.scanner.ScannerConfiguration.ADF) {
            scan.duplex = wsd.scanner.ScannerConfiguration.ADF.ADFSupportsDuplex
              ? true
              : false;
          } else if (
            wsd.microsoft &&
            wsd.microsoft.ScannerConfiguration &&
            wsd.microsoft.ScannerConfiguration.ADF
          ) {
            scan.duplex = wsd.microsoft.ScannerConfiguration.ADF
              .ADFSupportsDuplex
              ? true
              : false;
          }
        }
      }
      if (wsd.printer) {
        const { PrinterCapabilities } = wsd.printer;
        if (PrinterCapabilities && !print.sizes.length) {
          const { JobValues } = PrinterCapabilities;
          if (JobValues) {
            const { DocumentProcessing } = JobValues;
            if (DocumentProcessing) {
              const { MediaSizeName } = DocumentProcessing;
              if (MediaSizeName) {
                const { AllowedValue } = MediaSizeName;
                if (AllowedValue) {
                  print.sizes = extractSizes(Object.values(AllowedValue));
                }
              }
            }
          }
        }
      }
    }

    if (!print.sizes.length) print.sizes = ["A4"];

    duplexSupported = print.duplex || scan.duplex;

    const divider = <div className="divider top-10 bottom-10"></div>;

    const doubleSided = (
      <div
        id="settings-double-switch"
        className="toggle-switch toggle-ios toggle-off toggle-animated"
        data-name="duplex"
        data-toggle-height="30"
        data-toggle-width="75"
        data-toggle-content="toggle-content-double"
        data-toggle-checkbox="toggle-checkbox-double"
        data-icons-size="9"
        data-bg-on="bg-green1-dark"
        data-bg-off="bg-blue1-dark"
      >
        <span
          className="color-theme regularbold font-14"
          style={{ lineHeight: 27 + "px" }}
        >
          Double-sided
        </span>
        <strong
          style={{ width: 30 + "px", height: 30 + "px", right: 45 + "px" }}
        ></strong>
        <i
          className="fa-t1 fas fa-check"
          style={{
            width: 30 + "px",
            lineHeight: 30 + "px",
            fontSize: 9 + "px",
            right: 45 + "px",
          }}
        ></i>
        <i
          className="fa-t2 fas fa-times"
          style={{
            width: 30 + "px",
            lineHeight: 30 + "px",
            fontSize: 9 + "px",
          }}
        ></i>
        <u
          className="bg-blue1-dark"
          style={{ width: 75 + "px", height: 30 + "px" }}
        ></u>
      </div>
    );

    const color = (
      <div
        id="settings-color-switch"
        className="toggle-switch toggle-ios toggle-off toggle-animated"
        data-name="color"
        data-toggle-height="30"
        data-toggle-width="75"
        data-toggle-content="toggle-content-color"
        data-toggle-checkbox="toggle-checkbox-color"
        data-icons-size="9"
        data-bg-on="bg-green1-dark"
        data-bg-off="bg-blue1-dark"
      >
        <span
          className="color-theme regularbold font-14"
          style={{ lineHeight: 27 + "px" }}
        >
          Colorful
        </span>
        <strong
          style={{ width: 30 + "px", height: 30 + "px", right: 45 + "px" }}
        ></strong>
        <i
          className="fa-t1 fas fa-check"
          style={{
            width: 30 + "px",
            lineHeight: 30 + "px",
            fontSize: 9 + "px",
            right: 45 + "px",
          }}
        ></i>
        <i
          className="fa-t2 fas fa-times"
          style={{
            width: 30 + "px",
            lineHeight: 30 + "px",
            fontSize: 9 + "px",
          }}
        ></i>
        <u
          className="bg-blue1-dark"
          style={{ width: 75 + "px", height: 30 + "px" }}
        ></u>
      </div>
    );

    const action = this.state.printer.state.action;
    const pages = this.state.settings.pages || `1-${this.props.pages}`;
    
    const client = this.state.app.state.client;

    let amount, currency;

    if (!client || !client.balance || !client.balance.amount) {
      amount = 0;
      currency = "ILS";
    } else {
      amount = Number(client.balance.amount).toFixed(2);
      currency = client.balance.currency;
    }

    let printCost = 0;
    if (this.props.pricing) {
      const priceAmount = this.state.settings.color ? this.props.pricing.print.color : this.props.pricing.print.bw;
      const selectedPages = calculatePages(pages, this.state.pages);
      printCost = (priceAmount || 0) * (selectedPages || 1) * (this.state.settings.copies || 1);
      printCost = Math.round(printCost * 100) / 100; // Fix floating point precision
      
      // console.log("Settings component - Print cost calculation:", {
      //   priceAmount,
      //   selectedPages,
      //   copies: this.state.settings.copies,
      //   printCost,
      //   amount,
      //   amountType: typeof amount,
      //   printCostType: typeof printCost,
      //   isGreater: printCost > amount,
      //   isDisabled: !this.state.validPageRange || (printCost > amount)
      // });
    }

    return (
      <div
        id="menu-settings-bottom"
        className="menu menu-box-bottom"
        data-menu-effect="menu-over"
        data-menu-select="page-components"
        style={{ height: "auto", opacity: 1, display: "block" }}
      >
        <div className="top-20">
          <h2 className="uppercase bold">Settings</h2>
          <p className="under-heading bottom-20">Confirm your job settings</p>
          { action === "print" && printCost && amount && <p className="under-heading bottom-20" style={{ fontSize: '1rem' }}>
            <div>Print cost: <b style={{ direction: "ltr" }}>{`${currency_symbols[currency.toUpperCase()]}${printCost.toFixed(2)}`}</b></div>
            <div>
              Your balance: <b style={{ direction: "ltr", color: printCost > amount ? "#ed143d" : "#006400" }} >{`${currency_symbols[currency.toUpperCase()]}${Number(amount).toFixed(2)}`}</b>
            </div>
          </p> }
          <div className="center-text-huge bottom-0">
            <div className="content">
              {duplexSupported ? doubleSided : null}
              {duplexSupported && colorSupported ? divider : null}
              {colorSupported ? color : null}
              {action != "scan" && (duplexSupported || colorSupported)
                ? divider
                : null}
              {action === "print" ? (
                <span className="color-theme regularbold font-14">
                  Page size
                </span>
              ) : null}
              {action === "print" && (
                <select
                  defaultValue={this.state.settings.size}
                  onChange={this.handleSizeChange}
                >
                  {print.sizes.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              )}
              {action === "print" && divider}
              {action != "scan" && (
                <span className="color-theme regularbold font-14">Copies</span>
              )}
              {action != "scan" && (
                <input
                  id="copies"
                  type="number"
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                  }}
                  onChange={this.handleCopiesChange}
                  value={this.state.settings.copies}
                  maxLength="2"
                />
              )}
              {action === "print" && divider}
              {action === "print" && (
                <span className="color-theme regularbold font-14">Pages</span>
              )}
              {action === "print" && (
                <input
                  id="page-range"
                  type="text"
                  onChange={this.handlePagesChange}
                  value={`${pages}`}
                />
              )}
            </div>
          </div>
          {(() => {
            const numAmount = Number(amount);
            const insufficient = action === "print" && this.props.pricing && printCost > numAmount;
            const delta = insufficient ? printCost - numAmount : 0;
            if (!this.state.validPageRange) {
              return (
                <button
                  disabled
                  className="button button-s button-center-large button-round-medium shadow-large bg-highlight disabled"
                >
                  {action}
                </button>
              );
            }
            if (insufficient) {
              return (
                <button
                  onClick={() => this.state.printer.topUpAndReturn(printCost)}
                  className="button button-s button-center-large button-round-medium shadow-large bg-highlight"
                >
                  {`Add ${currency_symbols[(currency || "ILS").toUpperCase()]}${delta.toFixed(2)} to balance`}
                </button>
              );
            }
            return (
              <button
                onClick={() => this.state.printer.startAction(action)}
                className="button button-s button-center-large button-round-medium shadow-large bg-highlight"
              >
                {action}
              </button>
            );
          })()}
        </div>
      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/pages/printer/settings.js